/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderFormConfiguration,
    ProviderFormConfigurationFromJSON,
    ProviderFormConfigurationToJSON,
    ProviderFormData,
    ProviderFormDataFromJSON,
    ProviderFormDataToJSON,
    ProviderValidationData,
    ProviderValidationDataFromJSON,
    ProviderValidationDataToJSON,
} from '../models';

export interface ApiProviderFormCreatePostRequest {
    providerFormData?: ProviderFormData;
}

export interface ApiProviderFormDataGetRequest {
    id?: string;
}

export interface ApiProviderFormUpdatePostRequest {
    providerFormData?: ProviderFormData;
}

export interface ApiProviderFormValidatePostRequest {
    providerFormData?: ProviderFormData;
}

/**
 * no description
 */
export class ProviderFormApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderFormConfigurationGetRaw(): Promise<runtime.ApiResponse<ProviderFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderFormConfigurationGet(): Promise<ProviderFormConfiguration> {
        const response = await this.apiProviderFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiProviderFormCreatePostRaw(requestParameters: ApiProviderFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderFormDataToJSON(requestParameters.providerFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProviderFormCreatePost(requestParameters: ApiProviderFormCreatePostRequest): Promise<void> {
        await this.apiProviderFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiProviderFormDataGetRaw(requestParameters: ApiProviderFormDataGetRequest): Promise<runtime.ApiResponse<ProviderFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderFormDataGet(requestParameters: ApiProviderFormDataGetRequest): Promise<ProviderFormData> {
        const response = await this.apiProviderFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderFormUpdatePostRaw(requestParameters: ApiProviderFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderFormDataToJSON(requestParameters.providerFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProviderFormUpdatePost(requestParameters: ApiProviderFormUpdatePostRequest): Promise<void> {
        await this.apiProviderFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiProviderFormValidatePostRaw(requestParameters: ApiProviderFormValidatePostRequest): Promise<runtime.ApiResponse<ProviderValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderFormDataToJSON(requestParameters.providerFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderFormValidatePost(requestParameters: ApiProviderFormValidatePostRequest): Promise<ProviderValidationData> {
        const response = await this.apiProviderFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
